//@author: devin
import { inject, Injectable } from "@angular/core";
import { SearchCriteriaContext } from "./search.criteria.context";

@Injectable({ providedIn: "root" })
export class SearchCriteriaAdvContext {
    private ctx = inject(SearchCriteriaContext).Context;

    readonly Context: Record<number, any> = {
        //security groups
        99: this.ctx.securityGroups,

        //events
        101000: this.ctx.assignedEventStates,
        101: this.ctx.eventStates,
        102: this.ctx.eventTypes,
        103: this.ctx.eventTypes,
        104: this.ctx.eventFolders,
        105: this.ctx.eventCabinets,
        107: this.ctx.events,
        108: this.ctx.eventSearches,
        192: this.ctx.eventSearches,
        110: this.ctx.organizations,
        112: this.ctx.organizations,
        111: this.ctx.contacts,
        185: this.ctx.contacts,
        113: this.ctx.organizationSearches,
        120: this.ctx.eventCategories,
        121: this.ctx.eventCategories,
        130: this.ctx.eventRequirements,
        131: this.ctx.eventRequirements,
        162: this.ctx.locationSearches,
        163: this.ctx.locations,
        165: this.ctx.locations,
        167: this.ctx.resourceSearches,
        168: this.ctx.resources,
        150: this.ctx.eventCustomAttributes,

        //locations
        20: this.ctx.locationRelatedTypes,
        471: this.ctx.events,
        470: this.ctx.eventSearches,
        405: this.ctx.locationSearches,
        407: this.ctx.locations,
        410: this.ctx.locationFeatures,
        411: this.ctx.locationFeatures,
        420: this.ctx.locationCategories,
        421: this.ctx.locationCategories,
        423: this.ctx.locationPartitions,
        424: this.ctx.locationPartitions,
        430: this.ctx.locationLayouts,
        433: this.ctx.locationLayouts,
        460: this.ctx.locations,
        461: this.ctx.locations,
        450: this.ctx.locationCustomAttributes,

        //resources
        671: this.ctx.events,
        670: this.ctx.eventSearches,
        605: this.ctx.resourceSearches,
        607: this.ctx.resources,
        6071: this.ctx.resourcesQuantity,
        620: this.ctx.resourceCategories,
        621: this.ctx.resourceCategories,
        660: this.ctx.resources,
        661: this.ctx.resources,
        650: this.ctx.resourceCustomAttributes,

        //organizations
        207: this.ctx.organizations,
        205: this.ctx.organizationSearches,
        220: this.ctx.organizationCategories,
        221: this.ctx.organizationCategories,
        210: this.ctx.contacts,
        230: this.ctx.organizationTypes,
        231: this.ctx.organizationTypes,
        280: this.ctx.organizationRatings,
        281: this.ctx.organizationRatings,
        271: this.ctx.events,
        270: this.ctx.eventSearches,
        250: this.ctx.organizationCustomAttributes,

        8001: this.ctx.ingestionFieldsAll,
        9001: this.ctx.workflowProcesses,
    };
}
